import React, { useEffect, useMemo, useState } from 'react';
import { Group, Pagination as MantinePagination, Text } from '@mantine/core';

type Props<T> = {
    data: T[];                          // весь отфильтрованный список
    itemsPerPage?: number;              // сколько на страницу (по умолчанию 25)
    setCurrentItems: (slice: T[]) => void; // отдать текущий срез наверх
    currentSearch?: string;             // чтобы сбрасывать страницу при изменении поиска
};

export const VideoListPagination = <T,>({
                                            data,
                                            itemsPerPage = 25,
                                            setCurrentItems,
                                            currentSearch,
                                        }: Props<T>) => {
    const [page, setPage] = useState(1);

    const pageCount = useMemo(
        () => Math.max(1, Math.ceil((data?.length ?? 0) / itemsPerPage)),
        [data, itemsPerPage]
    );

    // сброс страницы при смене фильтров/поиска
    useEffect(() => {
        setPage(1);
    }, [currentSearch, itemsPerPage, data]);

    // отдаём наверх текущий срез
    useEffect(() => {
        const start = (page - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        setCurrentItems((data ?? []).slice(start, end));
    }, [page, itemsPerPage, data, setCurrentItems]);

    if (!data || data.length === 0) {
        return (
            <Group justify="center" mt="md">
                <Text c="dimmed">No videos found</Text>
            </Group>
        );
    }

    return (
        <Group justify="center" mt="md">
            <MantinePagination
                value={page}
                onChange={setPage}
                total={pageCount}
                // Mantine v7/8: здесь нет getItemAriaLabel — убираем его
            />
        </Group>
    );
};
